<kui-modal size='lg'
    class="console-modal"
    [title]="'ADMIN.EDITORS.DEVICE.CONSOLE.TITLE' | translate"
    (onClose)="detachModal()"
    [actions]="modalActions">

    <div class="console-content d-flex flex-column">

        <div class="console flex-1">
            <div *ngFor="let line of lines">{{ line }}</div>
        </div>
        <div class="text" *ngIf="!!ws">
            <input 
                kui-input
                [placeholder]="'ADMIN.EDITORS.DEVICE.CONSOLE.TEXT_TIP' | translate"
                [(ngModel)]="text"
                (keydown.enter)="onSend($event)" />
        </div>

    </div>
</kui-modal>